import type { ContractFileOrDirectory } from './bucket-api';

/**
 * Chemins de l'explorateur. Le backend parle en **préfixes S3** : la racine est `''` (envoyée `/`),
 * un répertoire finit par `/` et ne commence jamais par `/` (`S3BucketStorageAdapter#getPath`).
 * L'URL de la console porte ce préfixe tel quel (`?path=raw/eco2mix/`).
 */
export function normalizePrefix(path: string | null | undefined): string {
  const trimmed = (path ?? '').replace(/^\/+/u, '');
  if (!trimmed) return '';
  return trimmed.endsWith('/') ? trimmed : `${trimmed}/`;
}

/** Fil d'Ariane : la racine, puis un segment par répertoire (`raw/`, `raw/eco2mix/`). */
export function breadcrumbOf(prefix: string): { label: string; path: string }[] {
  const segments = normalizePrefix(prefix).split('/').filter(Boolean);
  return segments.map((label, index) => ({ label, path: `${segments.slice(0, index + 1).join('/')}/` }));
}

/** Répertoire parent d'un préfixe (`raw/eco2mix/` → `raw/`, `raw/` → `''`). */
export function parentOf(prefix: string): string {
  const segments = normalizePrefix(prefix).split('/').filter(Boolean);
  segments.pop();
  return segments.length > 0 ? `${segments.join('/')}/` : '';
}

/** Nom affiché : le dernier segment, sans barre finale pour un répertoire. */
export function displayName(entry: ContractFileOrDirectory): string {
  const raw = entry.name || entry.path || '';
  const segments = raw.split('/').filter(Boolean);
  return segments.at(-1) ?? raw;
}

/** Chemin complet d'une entrée (clé S3 d'un objet, préfixe d'un répertoire). */
export function entryPath(entry: ContractFileOrDirectory, prefix: string): string {
  if (entry.path) return entry.path.replace(/^\/+/u, '');
  return `${normalizePrefix(prefix)}${entry.name ?? ''}`;
}
